// src/lib/cacheBus.js — invalidação de cache por ASSUNTO (12/07).
//
// Os módulos cacheiam listas por 2–5 min (tenant.registerCache). Sem invalidar, quem
// cria uma obra volta para a lista e NÃO a vê — o dado está no banco, a tela é que
// está velha. Só o financeiro invalidava; os outros 7 não.
//
// Uso, logo após um insert/update/delete bem-sucedido:
//   import { invalidar } from '../../lib/cacheBus.js';
//   invalidar('obras');            // limpa obras-list + o que depende de obras
//
import { tenant } from '../context/tenantContext.js';

// Um assunto pode afetar mais de uma tela (uma obra nova muda a lista, o dashboard e o mapa).
const AFETA = {
  obras:        ['obras-list', 'dashboard-data', 'mapa-painel'],
  clientes:     ['clientes-list', 'dashboard-data'],
  funcionarios: ['funcionarios-list', 'rh-dashboard', 'dashboard-data'],
  tarefas:      ['tarefas-list', 'dashboard-data'],
  financeiro:   ['financeiro-caixa', 'dashboard-data'],
  rh:           ['rh-dashboard', 'dashboard-data'],
};

export function invalidar(...assuntos) {
  const chaves = new Set();
  assuntos.forEach((a) => (AFETA[a] || [a]).forEach((k) => chaves.add(k)));
  chaves.forEach((k) => {
    try { tenant.invalidateCache(k); } catch (_) {}
  });
}
